import { TTnAOrderTemplateActions } from './tna-order-template.actions';
import { TTnAOrderTemplateActionType, TTnAOrderTemplateState } from './tna-order-template.models';

export const initialState: TTnAOrderTemplateState = {
  tnaOrderTemplateInfo: null,
  showTnAOrderTemplatesLoader: false,
};

export function tnaOrderTemplateReducer(
  state = initialState,
  action: TTnAOrderTemplateActions,
): TTnAOrderTemplateState {
  switch (action.type) {
    case TTnAOrderTemplateActionType.SetShowTnAOrderTemplatesLoader:
      return {
        ...state,
        showTnAOrderTemplatesLoader: action.showLoader,
      };
    case TTnAOrderTemplateActionType.ClearTnAOrderTemplates:
      return {
        ...state,
        tnaOrderTemplateInfo: null,
      };
    case TTnAOrderTemplateActionType.GetTnAOrderTemplates:
      return {
        ...state,
        tnaOrderTemplateInfo: null,
      };
    case TTnAOrderTemplateActionType.GetTnAOrderTemplatesSuccess:
      return {
        ...state,
        tnaOrderTemplateInfo: action.tnaOrderTemplateRes,
      };
    default:
      return state;
  }
}
